/*
* Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
* SPDX-License-Identifier: MIT
*
* Licensed under the MIT License. See the LICENSE accompanying this file
* for the specific language governing permissions and limitations under
* the License.
*/

import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { AmplifyConfirmSignUp, } from '@aws-amplify/ui-react';
import { Translations } from "@aws-amplify/ui-components";
import { I18n } from '@aws-amplify/core';

const mapStateToProps = (state) => {
	return {
		email: state.user.attributes?.email || '',
		user: state.user
	}
};

const RegisterConfirm = (props) => {
	useEffect(() => {
		const dictLang = {
			"Confirm Sign up": "Conferma registrazione",
			"Confirm": "Ok ho confermato"
		};
		I18n.putVocabulariesForLanguage("it", dictLang);
		I18n.putVocabulariesForLanguage("en", dictLang);

	}, [])
	return (
		<AmplifyConfirmSignUp className="register-confirm"
			usernameAlias="email"
			slot="confirm-sign-up"
			formFields={[
				{
					type: "email",
					required: false,
					value: props.email,
					label: I18n.get("REGISTER_CONFIRM_EMAIL_LABEL"),
					inputProps: {
						type: 'hidden',
					}
				}
			]}
			handleSubmit={async (e) => {
				//riporta i query parameters nella home
				window.location.href = `${window.location.origin}${window.location.search}`
				e.preventDefault()
				e.stopPropagation();
			}}
		/>
	);
}

export default connect(mapStateToProps, {})(RegisterConfirm);
